import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { Calendar } from "primereact/calendar";

import { useForm } from "../../../../Base/Hooks/useForm";
import Loader from "../../../../Base/Components/Loader/Loader";
import MultiSelectDropdown from "../../../../Base/Components/Form/MultiSelectDropdown";

import { getUsuariosActivos } from "../../../../Base/API/IT/Users/UserRequests";
import { toastShow } from "../../../../Base/Services/ToastService";


const EntrevistaModal = ({ showDialog, setShowDialog, agregarDatosEntrevista }) => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  

  const initialValues = {

  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const usuariosTempo = await getUsuariosActivos()
    setUsuarios(usuariosTempo)

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if(selectedUsers.length <= 0){
        error.selectedUsers = true;
        error.error = true;
    }
    if (!values.DateEntrevista) {
        error.DateEntrevista = true;
        error.error = true;
    }
    if (!values.ComentarioEntrevista) {
        error.ComentarioEntrevista = true;
        error.error = true;
    }

    setError(error);
    return error;
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
            let e = verificarInfo()
            if(!e.error){
              const data = {
                DateEntrevista: values?.DateEntrevista,
                ComentarioEntrevista: values?.ComentarioEntrevista,
                IdUsersEntrevista: selectedUsers?.map(i=> i?.IdUser).join(','),
                UsersEntrevista: selectedUsers?.map(i=> i?.UserName).join(','),
                Entrevista: true,
              }
              agregarDatosEntrevista(data)
            }else{
              toastShow(toast, 'error', 'Error', 'Agregue los campos requeridos.' )
            }
        }}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = "Datos de Entrevista";

  return (
    <div>
      <Dialog
        visible={showDialog}
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: '50%'}}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div>
            <div className="d-flex mx-4">
                <div div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                        <Calendar
                            id="DateEntrevista"
                            name="DateEntrevista"
                            value={values?.DateEntrevista}
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            style={{width: '100%'}}
                            maxDate={new Date()}
                            onChange={(e) => handleInputChange(e, "DateEntrevista")}
                            showIcon
                            className={error.DateEntrevista ? "p-invalid" : ""}
                        />
                    <label htmlFor="DateEntrevista">Fecha Entrevista</label>
                    </span>
                </div>

                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                    <MultiSelectDropdown
                        name="UserName"
                        value={selectedUsers}
                        setValue={setSelectedUsers}
                        items={usuarios}
                        style={{width: '100%'}}
                        field="UserName"
                        placeholder="Seleccione Entrevistador"
                        label="Entrevistador"
                        className={error.selectedUsers ? "p-invalid" : ""}
                    />
                    </span>
                </div>
            </div>

            <div className="d-flex mx-4">
              <div div className="field col-12 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="ComentarioEntrevista"
                    value={values.ComentarioEntrevista}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.ComentarioEntrevista ? "p-invalid" : ""}
                  />
                  <label htmlFor="ComentarioEntrevista">Comentario</label>
                </span>
              </div>
            </div>

          </div>
        </div>
      </Dialog>

      
    </div>
  );
};

export default EntrevistaModal;
